export const getSavedViewURL = ({
  baseURL,
  viewId,
}: {
  baseURL?: string;
  viewId: string;
}): string => {
  return `${baseURL || ''}?savedView=${viewId}`;
};
